import { UserApi } from 'api/api'
import { API_ERRORS } from 'api/constants'
import { toast } from 'react-hot-toast'
import { useMutation } from 'react-query'

export const useJoinMiniLeague = () => {
  const { data, mutate, isLoading, error, mutateAsync } = useMutation({
    mutationFn: (miniLeagueId) => UserApi.joinToMiniLeague(miniLeagueId as any),
    onError: (error: any) =>
      toast.error(`${API_ERRORS[error.response?.data.detail as keyof typeof API_ERRORS]}`, {
        duration: 5000,
      }) as unknown as void,
    retry: false,
  })

  return { data, isLoading, mutate, error, mutateAsync }
}
